module.exports = __webpack_public_path__ + "assets/img/29_195_big.f73a27a1.jpg";